import { generator } from  '../event-listener';

export const OnNavigate = generator('onNavigate');
